import { useState } from "react";
import { Container, Row , Col  } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import { db } from "../firebaseConfig";
import { addDoc , collection } from "firebase/firestore";
import emailjs from '@emailjs/browser';
import { useRef } from "react";
import { Button, Modal } from 'react-bootstrap';

export const Contact = () =>{
    const form = useRef();
    const formInitialDetails = {
        firstName:'',
        lastName:'',
        email:'',
        phone:'',
        message:''
    }

    const [formDetails , setFormDetails] = useState(formInitialDetails);
    const [buttonText , SetButtonText] = useState('Send');

    const userCollectionRef = collection(db,'contactdata');
    const onFormUpdate =(category , value) =>{
        setFormDetails({
            ...formDetails,
            [category]:value
        })
    }

    const handleSubmit = async(e) =>{
        e.preventDefault();
        SetButtonText('Sending...');
        addDoc(userCollectionRef,{
            ...formDetails
        });
        emailjs.sendForm('service_88vqbin','template_2pdlv1p',form.current,'Q_iuyOF4OUoMCDW7f').then((result)=>{
            console.log(result.text);
        },(error)=>{
            console.log(error.text);
        });
        SetButtonText("Send");
        if (buttonText==="Send"){ console.log("Message Sent Successfully!.");}
        else {alert("Server is facing some problem!")}
        
        setFormDetails(formInitialDetails);
    };
    const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    if (formDetails.firstName !=="" && formDetails.email!==""){
    setShow(true);
    }else{
        alert(
            "fill required fields!"
        )
    }
  }

    return (
        <section className="contact" id="connect">
            <Container>
                <Row className="align-items-center">
                    <Col md={6}>
                        <img src={contactImg} alt="Contact US"/>
                    </Col>
                    <Col md={6}>
                        <h2>Get In Touch</h2>
                        <form ref={form} onSubmit={handleSubmit}>
                            <Row>
                                <Col sm={6} className="px-1">
                                    <input  type="text" value = {formDetails.firstName} placeholder="First Name" name="user_first_name" onChange ={(e)=>onFormUpdate('firstName',e.target.value)} required/>
                                </Col>
                                <Col sm={6} className="px-1">
                                    <input type="text" value = {formDetails.lastName} placeholder="Last Name" name="user_last_name" onChange ={(e)=>onFormUpdate('lastName',e.target.value)} />
                                </Col>
                                <Col sm={6} className="px-1">
                                    <input type="email" value = {formDetails.email} placeholder="Email Address" name="user_email" onChange ={(e)=>onFormUpdate('email',e.target.value)}required/>
                                </Col>
                                <Col sm={6} className="px-1">
                                    <input type="tel" value = {formDetails.phone} placeholder="Phone No" name="user_phone" onChange ={(e)=>onFormUpdate('phone',e.target.value)}/>
                                </Col>
                                <Col>
                                    <textarea row ={6} value = {formDetails.message} placeholder="Message" name="user_message" onChange={(e)=>onFormUpdate('message',e.target.value)} />
                                    <button type="submit" onClick={handleShow} ><span>{buttonText}</span></button>
                                </Col>
                            </Row>
                        </form>
                        <Modal className="popupcontent" show={show} onHide={handleClose}>
                        <Modal.Body>
                        <p> Message Send Successfully 🔥  </p>
                        </Modal.Body>
                       
                        <Button variant="secondary" onClick={handleClose}>
                            close
                        </Button>
                        
                        </Modal>
                    </Col>
                </Row>
            </Container>
        </section>

    )
}